import React from 'react';

const DepartmentsUsers = () => {
  return (
    <div className="card">
      <div className="card-header">
        <h2 className="text-xl">Użytkownicy działu</h2>
      </div>
      <div className="card-body">
        <p className="text-gray-600">Użytkownicy działu - do implementacji</p>
      </div>
    </div>
  );
};

export default DepartmentsUsers;
